import React, { Component } from "react";
import { Row, Col, Table, Tooltip, OverlayTrigger } from "react-bootstrap";
import moment from "moment";
import Card from "components/Card/Card.jsx";
import CustomButtom from "components/CustomButton/CustomButton.jsx";
import { fetchFormsByEmployeeRequest, deleteFormRequest } from "../../api/form";
import { getFullName } from '../../helpers/functions/employee';

class ListForms extends Component {

  state = {
    data: null,
    error: null
  };

  componentDidMount() {
    if (!this.state.data)
      this.fetchFormsData(this.props.id)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.id !== this.props.id) {
      this.fetchFormsData(nextProps.id)
    }
  }

  fetchFormsData(id){
    fetchFormsByEmployeeRequest(
      id,
      result => this.setState({data: result, error: null}),
      error => this.setState({error: error})
    )
  };

  deleteForm = (id) => {
    deleteFormRequest(
      id,
      result => this.fetchFormsData(this.props.id),
      error =>
        this.setState({ error: "There was an error deleting instance" })
    );
  }

  buildFormType = (formType, applicationType) => {
    let result;
    if (formType !== "leave-undertime") {
      result = formType;
    } else {
      result = applicationType;
    }

    return result;

  }

  buildFormDetailsContent = (formObj) => {
    const {
      formType,
      applicationType,
      date,
      timeFrom,
      timeTo,
      startDate,
      endDate,
      hoursRequested
    } = formObj;

    let details = '';

    if (formType === "ot-request") {
      details += `Hours requested: ${hoursRequested}`
    } else if (formType === "travel-order") {
      details += `From: ${moment.utc(startDate).format("MM/DD/YYYY")}, To: ${moment.utc(endDate).format("MM/DD/YYYY")}.`
    } else if (formType === "attendance") {
      details += `Date: ${moment.utc(date).format("MM/DD/YYYY")}.`
    } else if (formType === "leave-undertime") {
      if (applicationType === "leave") {
        details += `From: ${moment.utc(startDate).format("MM/DD/YYYY")}, To: ${moment.utc(endDate).format("MM/DD/YYYY")}.`
      } else if (applicationType === "undertime") {
        details += `Date: ${moment.utc(date).format("MM/DD/YYYY")}, From: ${timeFrom}, To: ${timeTo}.`
      }
    }

    return details;
  }

  render() {
    const { data } = this.state;
    const view = <Tooltip id="view_tooltip">View</Tooltip>;
    const remove = <Tooltip id="remove_tooltip">Remove</Tooltip>;

    return (
      <div className="content">
          <Row>
            <Col md={12}>
              <Card
                title="Forms Table"
                category="List of Forms entries to DB"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div>
                    <Table striped hover>
                      <thead>
                        <tr>
                          <th>Date Created</th>
                          <th>Type</th>
                          <th>Details</th>
                          <th>Status</th>
                          <th>Approved By</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {data && data.length > 0 
                          ? data.map(instance => {

                            return (
                              <tr key={instance._id}>
                                <td>{moment(instance.createdAt).format("MM/DD/YYYY") || "N/A"}</td>
                                <td>{this.buildFormType(instance.formType, instance.applicationType)}</td>
                                <td>{this.buildFormDetailsContent(instance)}</td>
                                <td>{instance.status || "N/A"}</td>
                                <td>{getFullName(instance.approvedBy) || "N/A"}</td>
                                <td className="td-actions text-right">
                                  <OverlayTrigger placement="top" overlay={view}>
                                    <CustomButtom 
                                      bsStyle="success" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.props.goToDetails(instance.formType, instance._id)}
                                    >
                                      <i className="fa fa-eye" />
                                    </CustomButtom>
                                  </OverlayTrigger>

                                  <OverlayTrigger placement="top" overlay={remove}>
                                    <CustomButtom 
                                      bsStyle="danger" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.deleteForm(instance._id)}
                                    >
                                      <i className="fa fa-times" />
                                    </CustomButtom>
                                  </OverlayTrigger>
                                </td>
                              </tr>
                            )}
                          )
                          : (
                            <tr>
                              <td colSpan='7'>There are no instances in the database yet.</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </Table>
                  </div>
                }
              />
            </Col>
          </Row>
      </div>
    );
  }
}

export default ListForms;
